import { DEFAULT_ROW_ELEMENT } from '@mobileConstants'
import { Row, RowElement } from '@mobileTypes'

import { ObjectFieldDTO } from '@types'

/**
 * Создание RowElement из ObjectFieldDTO
 */
export const createRowElementFromField = (
  field: ObjectFieldDTO & { objectCode?: string },
  commandKey: string,
  order: number
): RowElement => {
  return {
    ...DEFAULT_ROW_ELEMENT,
    code: field.name,
    order,
    title: field.name,
    value: field.name,
    objectCode: field.objectCode || '',
    valueType: field.valueType,
    fieldType: (field.type as any) === 'LINK' ? 'object_link' : 'single',
    columnToSort: field.name,
  } as RowElement
}

/**
 * Изменение порядка элементов внутри Row
 */
export const reorderRowElements = (
  elements: RowElement[],
  startIndex: number,
  endIndex: number
): RowElement[] => {
  const result = Array.from(elements)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)

  // Обновляем order
  return result.map((el, index) => ({ ...el, order: index }))
}

/**
 * Добавить новый элемент в Row
 */
export const addElementToRow = (row: Row, newElement: RowElement): Row => {
  const updatedElements = [...row.elements, newElement]

  return {
    ...row,
    elements: updatedElements.map((el, index) => ({ ...el, order: index })),
  }
}

/**
 * Удалить элемент из Row
 */
export const removeElementFromRow = (row: Row, elementIndex: number): Row => {
  const updatedElements = row.elements.filter((_, index) => index !== elementIndex)

  return {
    ...row,
    elements: updatedElements.map((el, index) => ({ ...el, order: index })),
  }
}

/**
 * Переместить элемент между Rows
 */
export const moveElementBetweenRows = (
  rows: Row[],
  sourceRowIndex: number,
  destRowIndex: number,
  sourceElementIndex: number,
  destElementIndex: number
): Row[] => {
  const newRows = Array.from(rows)
  const sourceRow = { ...newRows[sourceRowIndex] }
  const destRow = { ...newRows[destRowIndex] }

  // Удаляем элемент из source
  const [movedElement] = sourceRow.elements.splice(sourceElementIndex, 1)

  // Добавляем элемент в destination
  destRow.elements.splice(destElementIndex, 0, movedElement)

  // Обновляем order в обоих Rows
  sourceRow.elements = sourceRow.elements.map((el, index) => ({ ...el, order: index }))
  destRow.elements = destRow.elements.map((el, index) => ({ ...el, order: index }))

  newRows[sourceRowIndex] = sourceRow
  newRows[destRowIndex] = destRow

  return newRows
}

/**
 * Изменить порядок Rows
 */
export const reorderRows = (rows: Row[], startIndex: number, endIndex: number): Row[] => {
  const result = Array.from(rows)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)

  return result
}

/**
 * Создать новый пустой Row
 */
export const createEmptyRow = (): Row => {
  return {
    elements: [],
  }
}

/**
 * Удалить Row по индексу
 */
export const removeRow = (rows: Row[], rowIndex: number): Row[] => {
  return rows.filter((_, index) => index !== rowIndex)
}
